import { useMediaQuery, useTheme } from '@mui/material'
import { Theme } from '@mui/material/styles'

export const TOUCH_LANDSCAPE_MEDIA_QUERY = '(hover: none) and (pointer: coarse) and (orientation: landscape)'

export function useIsMobileLayout(): boolean {
  const theme = useTheme()
  const isBelowMd = useMediaQuery(theme.breakpoints.down('md'))
  const isTouchLandscape = useMediaQuery(TOUCH_LANDSCAPE_MEDIA_QUERY)
  return isBelowMd || isTouchLandscape
}

export function mobileLayoutStyles<T>(theme: Theme, styles: T): Record<string, T> {
  return {
    [theme.breakpoints.down('md')]: styles,
    [`@media ${TOUCH_LANDSCAPE_MEDIA_QUERY}`]: styles,
  }
}
